export var ContentJustification;
(function (ContentJustification) {
    ContentJustification[ContentJustification["Start"] = 0] = "Start";
    ContentJustification[ContentJustification["Center"] = 1] = "Center";
    ContentJustification[ContentJustification["End"] = 2] = "End";
    ContentJustification[ContentJustification["Stretch"] = 3] = "Stretch";
})(ContentJustification || (ContentJustification = {}));
export var ContentLocation;
(function (ContentLocation) {
    ContentLocation[ContentLocation["Start"] = 0] = "Start";
    ContentLocation[ContentLocation["Center"] = 1] = "Center";
    ContentLocation[ContentLocation["End"] = 2] = "End";
})(ContentLocation || (ContentLocation = {}));
export var ContentOrientation;
(function (ContentOrientation) {
    ContentOrientation[ContentOrientation["Column"] = 0] = "Column";
    ContentOrientation[ContentOrientation["Row"] = 1] = "Row";
})(ContentOrientation || (ContentOrientation = {}));
export var ContentSize;
(function (ContentSize) {
    ContentSize[ContentSize["Small"] = 0] = "Small";
    ContentSize[ContentSize["Medium"] = 1] = "Medium";
    ContentSize[ContentSize["Large"] = 2] = "Large";
    ContentSize[ContentSize["Auto"] = 3] = "Auto";
    ContentSize[ContentSize["ExtraLarge"] = 4] = "ExtraLarge";
})(ContentSize || (ContentSize = {}));
